"use client";

import React from "react";
import { Breadcrumb } from "@/components/ui/breadcrumb";
import { useTranslations } from "next-intl";
import { usePathname } from "next/navigation";

interface LegalLayoutProps {
  children: React.ReactNode;
  pageTitle: string;
  lastUpdated: string;
}

export default function LegalLayout({
  children,
  pageTitle,
  lastUpdated,
}: LegalLayoutProps) {
  const t = useTranslations("breadcrumb");
  const pathname = usePathname();
  const locale = pathname?.split("/")[1] || "en";

  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-50 via-white to-rose-50 dark:bg-gradient-to-b dark:from-background dark:via-background/95 dark:to-muted/20 transition-colors">
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <div className="rounded-3xl border border-white/60 bg-white/85 p-8 shadow-xl backdrop-blur dark:border-border/60 dark:bg-card/60 dark:shadow-2xl transition-colors">
          <header className="mb-8 text-center">
            <div className="mb-4 flex justify-center">
              <Breadcrumb
                items={[
                  { href: `/${locale}`, name: t("home") },
                  { href: "#", name: pageTitle },
                ]}
              />
            </div>
            {/* 主标题 (H1) - text-2xl, font-bold, tracking-tight */}
            <h1 className="text-2xl md:text-2xl font-bold tracking-tight text-gray-900 dark:text-gray-200 mt-4 space-y-3">
              {pageTitle}
            </h1>
            {/* 次要文本 - text-sm, text-muted-foreground */}
            <p className="mt-2 text-sm text-muted-foreground dark:text-slate-300">
              {t("lastUpdated")}: {lastUpdated}
            </p>
          </header>
          <article className="max-w-none space-y-6">{children}</article>
        </div>
      </div>
    </div>
  );
}
